import React from 'react';
import ReactDOM from 'react-dom';
import { produce } from 'immer';

import { FormElement } from '../Components/FormElement';
import { crmFormElementNameByElementId } from '../Util';
import { SelectionOverlay } from '../Components/SelectionOverlay';

export class App extends React.Component {
  constructor(props) {
    super(props);

    const formElements = this.loadFormElementData(props);

    this.state = {
      workshops: props.workshops,
      workshopGroups: props.workshopGroups,
      overlayElementId: null,
      formElements,
    };
  }

  loadFormElementData(props) {
    return props.workshopElements.reduce(function (acc, config) {
      let value = {};

      const { id, selectBtnLabel } = config;

      const inputEl = document.querySelector(
        `[name="${crmFormElementNameByElementId(id)}"]`
      );
      if (!inputEl) {
        return acc;
      }

      let incomingValue = inputEl.value;
      if (incomingValue) {
        try {
          value = JSON.parse(incomingValue);
        } catch (err) {
          console.error(err);
          return acc;
        }
      }
      $(inputEl).remove();

      acc[id] = {
        id,
        selectBtnLabel,
        el: document.querySelector(`[data-element-identifier="${id}"]`),
        inputName: inputEl.name,
        value,
      };

      return acc;
    }, {});
  }

  onOpenOverlayClick = (evt) => {
    const elementId = evt.target.dataset.id;

    this.setState(
      produce(this.state, function (draft) {
        draft.overlayElementId = elementId;
      })
    );
  };

  onSelectEventClick = (evt) => {
    const elementId = evt.currentTarget.dataset.id;
    const workshop = evt.currentTarget.dataset.workshop;

    this.setState(
      produce(this.state, function (draft) {
        if (draft.formElements[elementId].value[workshop]) {
          draft.formElements[elementId].value[workshop] = false;
        } else {
          draft.formElements[elementId].value[workshop] = true;
        }
      })
    );
  };

  onCloseOverlayClick = () => {
    this.setState(
      produce(this.state, function (draft) {
        draft.overlayElementId = null;
      })
    );
  };

  render() {
    return (
      <React.Fragment>
        {Object.keys(this.state.formElements).map((key) => {
          const { id, el, value, inputName, selectBtnLabel } =
            this.state.formElements[key];
          return ReactDOM.createPortal(
            <FormElement
              id={id}
              selectBtnLabel={selectBtnLabel}
              onOpenOverlayClick={this.onOpenOverlayClick}
              workshops={this.state.workshops}
              inputName={inputName}
              value={value}
            />,
            el
          );
        })}
        {this.state.overlayElementId ? (
          <SelectionOverlay
            id={this.state.overlayElementId}
            value={this.state.formElements[this.state.overlayElementId].value}
            workshopGroups={this.state.workshopGroups}
            onSelectEventClick={this.onSelectEventClick}
            onCloseOverlayClick={this.onCloseOverlayClick}
            workshops={this.state.workshops}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
